const destructive = "_destructive_bh2qc_83";
const styles = {
  "icon-button": "_icon-button_bh2qc_17",
  "subtle-bg": "_subtle-bg_bh2qc_38",
  destructive
};
export {
  styles as default,
  destructive
};
//# sourceMappingURL=IconButton.module.css.js.map
